import type { ApiKeyView, OperatingMode } from '@/api/types';
import { driftedPermissions } from '@/lib/keyPermissions';

/**
 * A key's permissions, with a warning for any the owner's current set no longer allows (a partner
 * switched back to DELEGATED keeps the content permissions on its keys, but they stop working).
 */
export function KeyPermissionsCell({
  apiKey,
  allowed,
  operatingMode,
}: {
  apiKey: ApiKeyView;
  allowed?: readonly string[] | undefined;
  operatingMode?: OperatingMode | undefined;
}) {
  const drifted =
    allowed && apiKey.status === 'ACTIVE' ? driftedPermissions(apiKey.permissions, allowed) : [];
  return (
    <div>
      <div>{apiKey.permissions.join(', ')}</div>
      {drifted.length > 0 && (
        <div className="text-xs text-destructive">
          {drifted.join(', ')} — not usable in {operatingMode} mode
        </div>
      )}
    </div>
  );
}
